import styled from 'styled-components';
import DefaultActionButton from 'components/Buttons/ActionButton';

const actionBarHeight = '6rem';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 26.875rem;
  grid-column-gap: 1.5rem;
  padding: 1.5rem 0 calc(1.5rem + ${actionBarHeight}) 0;
`;

export const Actions = styled.div`
  position: fixed;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(0, 0, 0, 0.1),
    0rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
  height: ${actionBarHeight};
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled(DefaultActionButton)`
  margin-left: 1rem;
`;

export const ButtonsBlock = styled.div`
  margin: auto;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadersWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  padding-bottom: 2rem;
  margin-bottom: 1.5rem;
`;
